import React from "react";
import styled from "styled-components";
import CodeMirror from "@uiw/react-codemirror";
import { javascript } from "@codemirror/lang-javascript";
import { oneDark } from "@codemirror/theme-one-dark";

const CodingEditor = ({ value, onChange }) => {
  return (
    <EditorContainer>
      <CodeMirror
        value={value}
        height="200px"
        theme={oneDark}
        extensions={[javascript({ jsx: true })]}
        onChange={(val, viewUpdate) => onChange(val)}
        basicSetup={{
          lineNumbers: true,
          foldGutter: false,
          highlightActiveLine: true,
        }}
        style={{
          borderRadius: "10px",
          overflow: "hidden",
          fontSize: "14px",
          background: "#1e1e1e",
        }}
      />
    </EditorContainer>
  );
};

const EditorContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.border || "#333"};
  border-radius: 10px;
  margin-top: 10px;
  box-shadow: ${({ theme }) => theme.shadow || "0 0 10px rgba(0,0,0,0.2)"};
  background: ${({ theme }) => theme.cardBg || "#111"};
  padding: 5px;
`;

export default CodingEditor;
